import API from '@/js/API'
window.API = API;

// 引入 axios
import '@/js/lib/request'


Vue.prototype.$message = ELEMENT.Message
Vue.prototype.$MessageBox = ELEMENT.MessageBox

Vue.prototype.bus = new Vue()

import AwesomeSwiper from 'vue-awesome-swiper'
window.AwesomeSwiper = AwesomeSwiper;
Vue.use(AwesomeSwiper);

// 引入 i18n 国际化插件
import { i18n } from '@/locales/index'
window.i18n = i18n

// 引入 jquery
Vue.prototype.$ = window.Jq = $

// 引入懒加载
import 'lazysizes'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import 'lazysizes/plugins/optimumx/ls.optimumx'
import 'lazysizes/plugins/attrchange/ls.attrchange'

window.lazySizesConfig = lazySizes.cfg || {}
window.lazySizesConfig.constrainPixelDensity = true

// 引入社交分享
import SocialSharing from 'vue-social-sharing'
Vue.use(SocialSharing)



import store from '@/js/store/index'
window.store = store

Vue.component('v-app', require('@/js/App.vue').default)
Vue.component('v-back-top', require('@/js/components/BackTop.vue').default)
Vue.component('v-breadcrumb', require('@/js/components/Breadcrumb.vue').default)
Vue.component('v-cartnum', require('@/views/venue/js/common/cartnum.vue').default)
Vue.component('v-empty-component', require('@/js/components/common/EmptyComponent.vue').default)
Vue.component('v-inlinecart', require('@/js/components/common/inlinecart.vue').default)
Vue.component('v-lazy-img', require('@/js/components/LazyImg.vue').default)
Vue.component('v-menu-tag', require('@/js/components/common/menuTag.vue').default)
Vue.component('v-paypal-btn', require('@/js/components/common/paypalBtn.vue').default)
Vue.component('v-scrolltext', require('@/js/components/common/scrollText.vue').default)
Vue.component('v-search-input', require('@/js/components/common/searchInput.vue').default)
Vue.component('v-selectlang', require('@/js/components/common/selectlang.vue').default)
Vue.component('v-selectprice', require('@/js/components/common/selectprice.vue').default)
Vue.component('v-payicon', require('@/js/components/common/payicon.vue').default)
Vue.component('v-product-card', require('@/views/venue/js/view/collections/ProductCard.vue').default)
Vue.component('v-banner', require('./common/banner.vue').default)
Vue.component('v-mark', require('@/js/components/view/mark/index.vue').default)
Vue.component('v-simplePrice', require('@/js/components/common/simplePrice.vue').default)
Vue.component('v-currencysymbol', require('@/js/components/common/currencysymbol.vue').default);
Vue.component('v-sellFeatures', require('@/js/components/common/sellFeatures.vue').default);

Vue.component('v-browsing-record',require('@/js/components/view/browsingRecord/browsingRecord.vue').default)
Vue.component('v-lastsales',require('@/js/components/view/lastsales/lastsales.vue').default)
Vue.component('v-custom-button',require('@/js/components/view/customButton/index.vue').default)

// 隐私政策
Vue.component('v-privacy-policy',require('@/js/components/view/privacyPolicy/index.vue').default);

// 引入公用方法挂入vue
import METHODS from '@/js/methods'
for (const key in METHODS) {
  if (METHODS.hasOwnProperty(key)) {
    Vue.prototype[key] = METHODS[key]
  }
  if (key == 'send_fb_event') {
    //默认像素事件
    METHODS[key]('PageView', {})
  }
}

import defaultImage from '@/images/vogue_df.png'
Vue.prototype.defaultImage = defaultImage


if (process.env.MIX_SENTRY_DSN && process.env.MIX_VERSION) {
  import(/* webpackChunkName: "sentry" */ `@/sentry/index`)
}

// 保存配置到全局状态
const { commit } = store

commit({
  type: 'settings/save',
  payload: {
    defaultNoImage: defaultImage,
  },
})

import googleAnalysis from '@/js/lib/ga'

// 谷歌分析插件
if (window.onGoogleAnalysisLoad) {
  const googleAnalysisLoad = (trackId, Ecommerce) => {
    // 保存ga信息
    commit({
      type: 'googleAnalysis/save',
      payload: {
        enable: !!trackId,
        trackId: trackId,
        ecommerce: !!parseInt(Ecommerce || 0, 2),
      },
    })
  }

  window.onGoogleAnalysisLoad(googleAnalysisLoad)

  delete window.onGoogleAnalysisLoad

  // 默认追踪页面
  googleAnalysis.page()
}

window.startup = function () {
  new Vue({
    el: '#app',
    store,
    i18n,
  })
}
